import { render, staticRenderFns } from "./pgForm.vue?vue&type=template&id=7284ed1c&scoped=true"
import script from "./pgForm.vue?vue&type=script&lang=js"
export * from "./pgForm.vue?vue&type=script&lang=js"
import style0 from "./pgForm.vue?vue&type=style&index=0&id=7284ed1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7284ed1c",
  null
  
)

export default component.exports